export default {"verifyEmail":"N2Rrz","iconContainer":"obySv","icon":"OS2x4","title":"xzj3y","content":"enfEg","text":"OI64t"};